import type { useCreateTermineForm } from '@/domain/termine/features/CreateTermin/shared/hooks/useCreateTermineForm';
import { createContext } from 'react';

export interface CreateTermineFormContextValue {
  form: ReturnType<typeof useCreateTermineForm>;
}

export const CreateTermineFormContext =
  createContext<CreateTermineFormContextValue | null>(null);
